var map = {
	"./academia-img1.svg": 584,
	"./academia-img2.svg": 585,
	"./academia-img3.svg": 586,
	"./business-img1.svg": 587,
	"./business-img2.svg": 588,
	"./business-img3.svg": 589,
	"./students-img1.svg": 590,
	"./students-img2.svg": 591,
	"./students-img3.svg": 592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;